import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const Logout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth();

  useEffect(() => {
    logout();              // ✅ central logout logic
    navigate("/login");    // ✅ redirect
  }, [logout, navigate]);

  return <div>{t("logout_form.message")}</div>;
};

export default Logout;